<template>
  <div>
    <div class="sga-page-3 page-3">
        <h3>Education</h3>
        <p>Please take a moment to build your skills profile by adding your education level, as well any certifications or licenses you hold. <strong><i>(Not applicable for those without formal education)</i></strong></p>

        <el-form @submit.native.prevent>
            <label role="text">
              Secondary Level Education
            </label>
            <el-form-item>
                <el-switch
                    v-model="sgaEducation.secondLevelEducation.noGedOrHsd"
                    active-color="#13ce66"
                    @change="handleChangeNoGEDOrHSD">
                </el-switch>
                &nbsp;<span>No GED/High School Diploma</span><br/>      


                <el-switch
                  v-model="sgaEducation.secondLevelEducation.highSchoolDiploma"
                  active-color="#13ce66"
                  @change="handleChangeGEDOrHSD">
                </el-switch>
                &nbsp;<span>High School Diploma</span> &nbsp;&nbsp; <br/>
                <el-checkbox v-model="sgaEducation.secondLevelEducation.highSchoolDiplomaAttending" @change="openGradDateModal('HSD', sgaEducation.secondLevelEducation.highSchoolDiplomaGraduationDate, sgaEducation.secondLevelEducation.highSchoolDiplomaAttending)">
                  <span v-if="sgaEducation.secondLevelEducation.highSchoolDiplomaAttending">
                    Currently attending, estimated graduation date is {{ this.sgaEducation.secondLevelEducation.highSchoolDiplomaGraduationDate | moment("MMMM DD, YYYY") }}
                  </span>
                  <span v-else>
                    Please mark this checkbox if you are currently attending this program                    
                  </span>
                </el-checkbox> 
                  
                <br/>

                <el-switch
                  v-model="sgaEducation.secondLevelEducation.ged"
                  active-color="#13ce66"
                  @change="handleChangeGEDOrHSD">
                </el-switch>
                &nbsp;<span>GED (General Equivalent Diploma)</span> &nbsp;&nbsp; <br/>
                <el-checkbox v-model="sgaEducation.secondLevelEducation.gedAttending" @change="openGradDateModal('GED', sgaEducation.secondLevelEducation.gedGraduationDate, sgaEducation.secondLevelEducation.gedAttending)">
                  <span v-if="sgaEducation.secondLevelEducation.gedAttending">
                    Currently attending, estimated graduation date is {{ this.sgaEducation.secondLevelEducation.gedGraduationDate | moment("MMMM DD, YYYY") }}
                  </span>
                  <span v-else>
                    Please mark this checkbox if you are currently attending this program                    
                  </span>
                </el-checkbox> 
                  
                <br/>

                <el-switch
                    v-model="sgaEducation.secondLevelEducation.leavingCert"
                    active-color="#13ce66">
                </el-switch>
                &nbsp;<span>Leaving Cert</span><br/>
                <el-switch
                    v-model="sgaEducation.secondLevelEducation.oLevels"
                    active-color="#13ce66"
                    @change="switch_OLevels">
                </el-switch>
                &nbsp;<el-tooltip placement="top">
                      <span> O-Levels / GCSEs <i class="fas fa-info-circle"></i></span>
                      <div slot="content" style="text-align: center">Only Applicable in UK country.</div>
                    </el-tooltip><br/>
                <el-form-item id="oleveldetails">
                    <div id="oleveldetails_template" v-for="(oleveldetails, index) in sgaEducation.secondLevelEducation.oLevelDetails" :key="index">
                        <el-select class="o-level-grade" v-model="oleveldetails.grade" style="width: 20%;">
                            <el-option value="A*">A*</el-option>
                            <el-option value="A">A</el-option>
                            <el-option value="B">B</el-option>
                            <el-option value="C*">C*</el-option>
                            <el-option value="C">C</el-option>
                            <el-option value="D">D</el-option>
                            <el-option value="E">E</el-option>
                        </el-select>  &nbsp;
                        <!-- <el-input min="50" max="100" type="number" class='o-level-grade' placeholder="Grade" v-model="oleveldetails.Grade"  style="width: 20%;"></el-input> &nbsp; -->
                        <el-input class='o-level-subject' placeholder="Subject" v-model="oleveldetails.subject"  style="width: 40%;"></el-input>
                        &nbsp;<i class="el-icon-remove delete_oleveldetails" style="color: #dc3c3c; font-size: 20px" @click="deleteOLevelDetails"></i>
                        &nbsp;<i class="el-icon-circle-plus add_oleveldetails" style="color: #13ce66; font-size: 20px" @click="addOLevelDetails"></i>
                    </div>
                </el-form-item>
                <el-switch
                    v-model="sgaEducation.secondLevelEducation.aLevels"
                    active-color="#13ce66"
                    @change="switch_ALevels">
                </el-switch>
                &nbsp;<el-tooltip placement="top">
                      <span> A-Levels <i class="fas fa-info-circle"></i> OR Equivalent</span>
                      <div slot="content" style="text-align: center">Only Applicable in UK country. <br>If you have a qualification equivalent to A Levels, <br>please input your grade below in the ‘grade’ dropdown and <br>input the subject and course title in the ‘Subject’ text field</div>
                    </el-tooltip><br/>
                <el-form-item id="aleveldetails">
                    <div id="aleveldetails_template" v-for="(aleveldetails, index) in sgaEducation.secondLevelEducation.aLevelDetails" :key="index">
                        <el-select class="a-level-grade" v-model="aleveldetails.grade" style="width: 20%;">
                            <el-option value="A*">A*</el-option>
                            <el-option value="A">A</el-option>
                            <el-option value="B">B</el-option>
                            <el-option value="C">C</el-option>
                            <el-option value="D">D</el-option>
                            <el-option value="E">E</el-option>
                        </el-select>  &nbsp;
                        <!-- <el-input min="50" max="100" type="number" class='a-level-grade' placeholder="Grade" v-model="aleveldetails.Grade" style="width: 20%;"></el-input> &nbsp; -->
                        <el-input class='a-level-subject' placeholder="Subject" v-model="aleveldetails.subject" style="width: 40%;"></el-input>
                        &nbsp;<i class="el-icon-remove delete_aleveldetails" style="color: #dc3c3c; font-size: 20px" @click="deleteALevelDetails"></i>
                        &nbsp;<i class="el-icon-circle-plus add_aleveldetails" style="color: #13ce66; font-size: 20px" @click="addALevelDetails"></i>
                    </div>
                </el-form-item>
            </el-form-item>
            <br>
            <!-- <el-select class="a-level-subject" style="width: 40%;">
                            <el-option value="A*">A*</el-option>
                            <el-option value="A">A</el-option>
                            <el-option value="B">B</el-option>
                            <el-option value="C">C</el-option>
                            <el-option value="D">D</el-option>
                            <el-option value="E">E</el-option>
                        </el-select> -->
            <hr>
            <label role="text">
              Third Level Education
            </label>
            <el-form-item>
              <el-switch
                  v-model="sgaEducation.thirdLevelEducation.associateDegree"
                  active-color="#13ce66"
                  @change="switch_AssociateDegree">
              </el-switch>
              &nbsp;<span>Associate Degree</span><br/>
              <el-form-item id="associatedegreedetails">
                  <div id="associatedegreedetails_template" v-for="(associatedegreedetails, index) in sgaEducation.thirdLevelEducation.associateDegreeDetails" :key="index">
                      <el-input class="associate-degree-title" placeholder="Course Title" v-model="associatedegreedetails.courseTitle" style="width: 40%;"></el-input> &nbsp;
                      &nbsp;<i class="el-icon-remove delete_associatedegreedetails" style="color: #dc3c3c; font-size: 20px" @click="deleteAssociateDegreeDetails"></i>
                      &nbsp;<i class="el-icon-circle-plus add_associatedegreedetails" style="color: #13ce66; font-size: 20px" @click="addAssociateDegreeDetails"></i>
                      &nbsp;&nbsp; <br/>
                      <el-checkbox class="associate-degree-attending" v-model="associatedegreedetails.currentlyAttending" @change="openAssocGradDateModal()">
                        <span v-if="associatedegreedetails.currentlyAttending">
                          Currently attending, estimated graduation date is {{ associatedegreedetails.graduationDate | moment("MMMM DD, YYYY") }}
                        </span>
                        <span v-else>
                          Please mark this checkbox if you are currently attending this program                    
                        </span>
                      </el-checkbox> <br/>  <input class="associate-degree-date" type="hidden" />            
                  </div>
              </el-form-item>

              <el-switch
                  v-model="sgaEducation.thirdLevelEducation.bachelorsDegree"
                  active-color="#13ce66"
                  @change="switch_BachelorsDegree">
              </el-switch>
              &nbsp;<span>Bachelors Degree</span><br/>
              <el-form-item id="bachelorsdegreedetails">
                  <div id="bachelorsdegreedetails_template" v-for="(bachelorsdegreedetails, index) in sgaEducation.thirdLevelEducation.bachelorsDegreeDetails" :key="index">
                      <el-input class="bachelors-degree-title" placeholder="Course Title" v-model="bachelorsdegreedetails.courseTitle" style="width: 40%;"></el-input> &nbsp;
                      &nbsp;<i class="el-icon-remove delete_bachelorsdegreedetails" style="color: #dc3c3c; font-size: 20px" @click="deleteBachelorsDegreeDetails"></i>
                      &nbsp;<i class="el-icon-circle-plus add_bachelorsdegreedetails" style="color: #13ce66; font-size: 20px" @click="addBachelorsDegreeDetails"></i>
                      &nbsp;&nbsp; <br/>
                      <el-checkbox class="bachelors-degree-attending" v-model="bachelorsdegreedetails.currentlyAttending" @change="openAssocGradDateModal()">
                        <span v-if="bachelorsdegreedetails.currentlyAttending">
                          Currently attending, estimated graduation date is {{ bachelorsdegreedetails.graduationDate | moment("MMMM DD, YYYY") }}
                        </span>
                        <span v-else>
                          Please mark this checkbox if you are currently attending this program                    
                        </span>
                      </el-checkbox> <br/>  <input class="bachelors-degree-date" type="hidden" />
                  </div>
              </el-form-item>
            </el-form-item>

            <br>
            <hr>
            <label role="text">
              Fourth Level Education
            </label>
            <el-form-item>
              <el-switch
                  v-model="sgaEducation.fourthLevelEducation.mastersDegree"
                  active-color="#13ce66"
                  @change="switch_MastersDegree">
              </el-switch>
              &nbsp;<span>Masters Degree</span><br/>
              <el-form-item id="mastersdegreedetails">
                    <div id="mastersdegreedetails_template" v-for="(mastersdegreedetails, index) in sgaEducation.fourthLevelEducation.mastersDegreeDetails" :key="index">
                        <el-input class="masters-degree-title" placeholder="Course Title" v-model="mastersdegreedetails.courseTitle" style="width: 40%;"></el-input> &nbsp;
                        &nbsp;<i class="el-icon-remove delete_mastersdegreedetails" style="color: #dc3c3c; font-size: 20px" @click="deleteMastersDegreeDetails"></i>
                        &nbsp;<i class="el-icon-circle-plus add_mastersdegreedetails" style="color: #13ce66; font-size: 20px" @click="addMastersDegreeDetails"></i>
                        &nbsp;&nbsp; <br/>
                        <el-checkbox class="masters-degree-attending" v-model="mastersdegreedetails.currentlyAttending" @change="openAssocGradDateModal()">
                          <span v-if="mastersdegreedetails.currentlyAttending">
                            Currently attending, estimated graduation date is {{ mastersdegreedetails.graduationDate | moment("MMMM DD, YYYY") }}
                          </span>
                          <span v-else>
                            Please mark this checkbox if you are currently attending this program                    
                          </span>
                        </el-checkbox> <br/>  <input type="hidden" class="masters-degree-date" />
                    </div>
              </el-form-item>
              <el-switch
                  v-model="sgaEducation.fourthLevelEducation.doctoralDegree"
                  active-color="#13ce66"
                  @change="switch_DoctoralDegree">
              </el-switch>
              &nbsp;<span>Doctoral Degree</span><br/>
              <el-form-item id="doctoraldegreedetails">
                    <div id="doctoraldegreedetails_template" v-for="(doctoraldegreedetails, index) in sgaEducation.fourthLevelEducation.doctoralDegreeDetails" :key="index">
                        <el-input class="doctoral-degree-title" placeholder="Course Title" v-model="doctoraldegreedetails.courseTitle" style="width: 40%;"></el-input> &nbsp;
                        &nbsp;<i class="el-icon-remove delete_doctoraldegreedetails" style="color: #dc3c3c; font-size: 20px" @click="deleteDoctoralDegreeDetails"></i>
                        &nbsp;<i class="el-icon-circle-plus add_doctoraldegreedetails" style="color: #13ce66; font-size: 20px" @click="addDoctoralDegreeDetails"></i>
                        &nbsp;&nbsp; <br/>
                        <el-checkbox class="doctoral-degree-attending" v-model="doctoraldegreedetails.currentlyAttending" @change="openAssocGradDateModal()">
                          <span v-if="doctoraldegreedetails.currentlyAttending">
                            Currently attending, estimated graduation date is {{ doctoraldegreedetails.graduationDate | moment("MMMM DD, YYYY") }}
                          </span>
                          <span v-else>
                            Please mark this checkbox if you are currently attending this program                    
                          </span>
                        </el-checkbox> <br/>  <input type="hidden" class="doctoral-degree-date" />
                    </div>
              </el-form-item>
            </el-form-item>
            <hr>
            <el-switch
                v-model="sgaEducation.sectorExperience.experience"
                active-color="#13ce66"
                @change="switch_Experience">
            </el-switch>
            &nbsp;<span style="font-size: 14px;">Sector Experience</span><br/>
            <br/>
            <el-form-item id="experiencedetails">
                <div id="experiencedetails_template" v-for="(experiencedetails, index) in sgaEducation.sectorExperience.experienceDetails" :key="index">
                    <el-select class="experience-sector" v-model="experiencedetails.title" placeholder="Please select a sector" style="width: 40%;">
                        <el-option
                        v-for="item in naicsLevel1Options"
                        :key="item.code"
                        :label="item.title"
                        :value="item.code">
                        </el-option>
                    </el-select> &nbsp;
                    <el-select class="experience-years" style="width: 20%;" v-model="experiencedetails.years">
                      <el-option value="Less than one year">Less than one year</el-option>
                      <el-option value="1-2 years">1-2 years</el-option>
                      <el-option value="3-5 years">3-5 years</el-option>
                      <el-option value="6-10 years">6-10 years</el-option>
                      <el-option value="10+ years">10+ years</el-option>
                    </el-select>
                    &nbsp;<i class="el-icon-remove delete_experience" style="color: #dc3c3c; font-size: 20px" @click="deleteExperienceDetails"></i>
                    &nbsp;<i class="el-icon-circle-plus add_experience" style="color: #13ce66; font-size: 20px" @click="addExperienceDetails"></i>
                </div>
            </el-form-item>
           <el-alert class="educ_alert" type="error" description="Field cannot be blank." > </el-alert>  
           <el-alert v-if="assocDateErr || batchDateErr || masterDateErr || doctorDateErr" type="error" title="Estimated graduation date must be a future date." :closable="false"> </el-alert>  
          <button class="ts-btn ts-btn-rounded ts-btn-secondary" @click="storeSection()">Continue</button>
          <a class="back-link" @click="goBack">
            <i class="fas fa-chevron-left"></i>Back
          </a>
        </el-form>
    </div>

    <el-dialog
      title="Estimated Graduation Date"
      :visible.sync="showDateModal"
      :close-on-click-modal="false"
      :show-close="false"
      width="380px"
      class="ts-modal"
    >
      <button
        type="button"
        aria-label="Close"
        class="el-dialog__headerbtn"
        @click="closeDateModal"
      >
        <i class="el-dialog__close el-icon el-icon-close"></i>
      </button>
      <el-form @submit.native.prevent style="margin-top: -10px">
        <el-form-item :error="selectedGradDateError" :required="true">
          <p style="margin-bottom: 0px">
            Please enter estimated graduation date:
          </p>
          <el-date-picker
            v-model="selectedGradDate"
            type="date"
            format="MM-dd-yyyy"
            placeholder="Select date and time"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>

      <el-row type="flex" style="margin-left: 70px">
        <el-button
          @click="closeDateModal"
          style="width: 80px"
          class="ts-btn ts-btn-small ts-btn-white"
          >Cancel</el-button
        >
        <el-button
          @click="setGraduationDate"
          style="width: 80px"
          class="ts-btn ts-btn-small ts-btn-primary"
          >Ok</el-button
        >
      </el-row>
    </el-dialog>

    <!-- <div id="bachelorsdegreedetails_template">
      <div class="el-input bachelors-degree-title" style="width: 40%;"> <input type="text" autocomplete="off" placeholder="Course Title" class="el-input__inner" /> </div>
      &nbsp; &nbsp;<i class="el-icon-remove delete_bachelorsdegreedetails" style="color: rgb(220, 60, 60); font-size: 20px;" ></i>&nbsp;<i class="el-icon-circle-plus add_bachelorsdegreedetails" style="color: rgb(19, 206, 102); font-size: 20px;"></i> <br>
      <div class="course-checkbox"><input type="checkbox" class="bachelors-degree-attending"> <i style="font-size:12px;color:#606266;padding-left: 3px;"> Please mark this checkbox if you are currently attending this program </i> </div>
      <input type="hidden" class="bachelors-degree-date" autocomplete="off"/> 
    </div> -->

    <questionnaire-print
      ref="questionnaire"
      :page1="page1"
      :page2="page2"
      :page3="page3"
      :page4="page4"
      :page5="page5"
      :page6="page6"
      :page7="page7"
      :page8="page8"
      :page9="page9"
      :page10="page10"
      :page11="page11"
      :page12="page12"
      currentPage="page3"
    >
    </questionnaire-print>
    <!-- <JobSeekerCV ref="cv" :Image="Base64Raw" :Data="currentSga" :UserInfo="currentUser" :ShowProfile="showProfile"></JobSeekerCV>  -->
    <JobSeekerCV
      ref="cv"
      :Data="profile.survey"
      :profile="profile"
      :Image="base64Raw"
      :UserInfo="currentUser"
      :ShowProfile="showProfile"
    ></JobSeekerCV>
    <ResumeListSelection
      :ProfileSettings="profileSettings"
      :ShowControl="showResumeListModal"
      @close-control="closeResumeListModal"
      @show-resume="displayResume"
    ></ResumeListSelection>
    <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
  </div>
</template>

<script>
import $ from "jquery";
import QuestionnairePrint from "../../components/QuestionnairePrint.vue";
import JobSeekerCV from "../../components/JobSeekerCV";
import TSLoading from "../../../../components/TSLoading.vue";
import ResumeListSelection from "../../components/ResumeListSelection.vue";

export default {
  components: {
    QuestionnairePrint,
    JobSeekerCV,
    TSLoading,
    ResumeListSelection,
  },
  created() {
    this.$store.dispatch('sga/getsga')
      .then((res) => {
        if (this.currentSga.sgaEmployeeInfo != null) {
          this.sgaEmployeeInfo = this.currentSga.sgaEmployeeInfo;
        }
        if (this.currentSga.sgaEducation != null) {
          //this.sgaEducation = this.currentSga.sgaEducation;
          this.sgaEducation  = Object.assign(this.sgaEducation, res.sgaEducation);          
        }
        $('div[role=alert]').hide();
      });
    
    this.$store.dispatch('onet/getSectorsByCodes', {}).then((res) => {
      this.naicsLevel1Options = res;
    });

    if (sessionStorage.getItem("profilephoto")) {
      this.base64Raw = sessionStorage.getItem("profilephoto");
    }
  },
  updated: function () {
    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been re-rendered
      // Code that will run only after the
      // entire view has been rendered
      if (!this.pageLoaded) {
        this.populatDateHiddenFields();
        this.pageLoaded = true;
      }
    });
  },
  mounted: function () {
    this.$router.app.$on("questionnaire-print", this.printPage);
    // this.$router.app.$on('cv-print', this.printPageAsCV);
    this.$router.app.$on("show-resume-list", this.showResumeList);
  },
  destroyed() {
    if (
      this.$route.matched.find((c) => c.path === "/sga/questionnaire") ===
      undefined
    ) {
      sessionStorage.removeItem("sgaDataForPrinting");
    } else {
      this.$router.app.$off("questionnaire-print", this.printPage);
      this.$router.app.$off("cv-print", this.printPageAsCV);
    }
  },
  data() {
    return {
      showResumeListModal: false,
      isLoading: false,
      hasError: false,
      modelState: {},
      sgaEmployeeInfo: {},
      sgaYourJob: {
        jobRole: {},
        jobDescriptionTasks: [],
        customTasks: []
      },
      sgaEducation: {
        secondLevelEducation: {
          noGedOrHsd: false,
          highSchoolDiploma: false,
          ged: false,
          oLevels: false,
          oLevelDetails: [],
          leavingCert: false,
          aLevels: false,
          aLevelDetails: [],
        },
        thirdLevelEducation: {
          associateDegree: false,
          associateDegreeDetails: [],
          bachelorsDegree: false,
          bachelorsDegreeDetails: [],
        },
        fourthLevelEducation: {
          mastersDegree: false,
          mastersDegreeDetails: [],
          doctoralDegree: false,
          doctoralDegreeDetails: [],
        },
        sectorExperience: {
          experience: false,
          experienceDetails: [],
        },
        naicsLevel1Options: {},
      },
      sgaWorkHistory: {
        userWorkHistory: []
      },
      sgaHiddenExtras: {
        workingPracticeActivities: []
      },
      sgaKnowledge: {
        knowledgeRegularlyUsed: []
      },
      sgaMindset: {
        mindsets: []
      },
      sgaSkills: {
        workingPracticeSkills: []
      },
      sgaTechnologies: {
        selectedTechnologies: [],
        customTechnologies: []
      },
      sgaHiddenTalents: {
        skillsKnowledgeOutsideWork: []
      },
      sgaCulture: {
        selectedCultureOptions: [],
        commuteDistance: '',
        transportation: []
      },
      sgaCertifications: {
        userCertifications: []
      },
      cvCollection: [],
      showProfile: true,
      base64Raw: null,
      profile: {},
      profileSettings: [],
      showDateModal: false,
      optionToSetDate: null,
      selectedGradDate: null,
      elementIndex: 0,
      htmlElem: null,
      selectedGradDateError: null,
      isFromElementUI: false,
      pageLoaded: false,
      assocDateErr: false,
      batchDateErr: false,
      masterDateErr: false,
      doctorDateErr: false,
    };
  },
  computed: {
    currentSga() {
      return this.$store.state.sga.current_sga;
    },
    currentUser() {
      return this.$store.state.account.current_user;
    },
    page1() {
      return sessionStorage.getItem("sgaDataForPrinting")
        ? JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page1
        : {};
    },
    page2() {
      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page2) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page2;
        } else {
          return {
            sgaYourJob: this.sgaYourJob,
            taskSearch: this.taskSearch,
            hiddenTasks: this.hiddenTasks,
          };
        }
      } else {
        return {
          sgaYourJob: this.sgaYourJob,
          taskSearch: this.taskSearch,
          hiddenTasks: this.hiddenTasks,
        };
      }
    },
    page3() {
      return {
        sgaEducation: this.sgaEducation,
      };
    },
    page4(){
      this.sgaWorkHistory.userWorkHistory.forEach(element => {
        if(element.workedFrom == '0001-01-01T00:00:00'){
          element.workedFrom = null;
        }
        if(element.workedTo == '0001-01-01T00:00:00'){
          element.workedTo = null;
        }
      });
      return {
        sgaWorkHistory: this.sgaWorkHistory,
      };
    },
    page5() {
      this.sgaCertifications.userCertifications.forEach(element => {
        if(element.acquiredDt == '0001-01-01T00:00:00'){
          element.acquiredDt = null;
        }
        if(element.expirationDt == '0001-01-01T00:00:00'){
          element.expirationDt = null;
        }
        if(element.image == undefined){
          element.image = null;
        }
      });
      return {
        sgaCertifications: this.sgaCertifications,
        selectedCodeDetail: this.selectedCodeDetail,
      };
    },
    page6() {
      return {
        sgaHiddenExtras: this.sgaHiddenExtras,
      };
    },
    page7() {
      return {
        sgaKnowledge: this.sgaKnowledge,
      };
    },
    page8() {
      return {
        sgaTechnologies: this.sgaTechnologies,
      };
    },
    page9() {
      return {
        sgaMindset: this.sgaMindset,
      };
    },
    page10() {
      return {
        sgaSkills: this.sgaSkills,
      };
    },
    page11() {
      return {
        sgaHiddenTalents: this.sgaHiddenTalents,
      };
    },
    page12() {
      return {
        sgaCulture: this.sgaCulture,
      };
    }

  },
    methods: {
      closeResumeListModal(){
        this.showResumeListModal = false;
      },
      showResumeList(){
        
        this.$store.dispatch('onlineprofile/getuserprofilepagesettings', this.currentUser.id)
        .then((res) => {
          
            this.profileSettings = res.filter(d => d.isActive == true);
            this.loading = false;
            this.showResumeListModal = true;
        })
        .catch(() => {
            this.loading = false;
        });
      },
      displayResume(setting){
        
        var obj = {
          userid: this.currentUser.id,
          cvid: setting.id
        }
        this.$store.dispatch('account/getprofiledetails', obj)
          .then((res) => {
            
            this.profile = res;
            this.showProfile = this.profile?.configuration?.profileConfiguration?.personalInformation?.profilePhoto;
            this.closeResumeListModal();

            this.$refs.cv.showCV(true);
            // this.showProfile = true;
            this.$refs.questionnaire.hideQuestionnaire();
            var x = this.$refs.cv.hideCV;
            window.setTimeout(function(){
              // action();
              window.print();
              x();
            }, 500);
        
          })
          .catch((res) => {

          });
      },
      goBack() {
        sessionStorage.setItem('NavigateAwayFrom', 'page3');
        this.$router.back();
      },
      switch_OLevels(){
        this.sgaEducation.secondLevelEducation.oLevelDetails = [];
          if(this.sgaEducation.secondLevelEducation.oLevels) {
              this.sgaEducation.secondLevelEducation.oLevelDetails.push({'grade': 'A*', 'subject': ''});
          }
      },
      addOLevelDetails(){
        var x =  { grade: 'A*', subject: '' };
        this.sgaEducation.secondLevelEducation.oLevelDetails.push(x);
      },
      deleteOLevelDetails(e){
        
          var container = e.currentTarget.closest("#oleveldetails_template");
          var x = container.parentElement;
          container.remove();
          if(x.innerHTML == '' || x.innerHTML == '<!---->'){
            this.sgaEducation.secondLevelEducation.oLevels = false;
            this.sgaEducation.secondLevelEducation.oLevelDetails = [];
          }
      },
      switch_ALevels(){
        this.sgaEducation.secondLevelEducation.aLevelDetails = [];
        if(this.sgaEducation.secondLevelEducation.aLevels) {
            this.sgaEducation.secondLevelEducation.aLevelDetails.push({'grade': 'A*', 'subject': ''});
        }
      },
      addALevelDetails(){
        var x =  { Grade: 'A*', Subject: '' };
        this.sgaEducation.secondLevelEducation.aLevelDetails.push(x);
      },
      deleteALevelDetails(e){
          var container = e.currentTarget.closest("#aleveldetails_template");
          var x = container.parentElement;
          container.remove();
          if(x.innerHTML == '' || x.innerHTML == '<!---->'){
            this.sgaEducation.secondLevelEducation.aLevels = false;
            this.sgaEducation.secondLevelEducation.aLevelDetails = [];
          }
      },
      switch_AssociateDegree(){
          if(!this.sgaEducation.thirdLevelEducation.associateDegree) {
              this.sgaEducation.thirdLevelEducation.associateDegreeDetails = [];
              document.getElementById("associatedegreedetails").innerHTML = '';
          }
          else{
              var row = '<div id="associatedegreedetails_template"><div class="el-input associate-degree-title" style="width: 40%;"> <input type="text" autocomplete="off" placeholder="Course Title" class="el-input__inner"> </div> ' + 
                '&nbsp;&nbsp; <i class="el-icon-remove delete_associatedegreedetails" style="color: rgb(220, 60, 60); font-size: 20px;" ></i>&nbsp;<i class="el-icon-circle-plus add_associatedegreedetails" style="color: rgb(19, 206, 102); font-size: 20px;"></i> <br>' +
                '<div class="course-checkbox"><input type="checkbox" class="associate-degree-attending"> <i style="font-size:12px;color:#606266;padding-left: 3px;"> Please mark this checkbox if you are currently attending this program </i> </input></div>' +                  
                '<input type="hidden" class="associate-degree-date" autocomplete="off"/> </div>' 
              
              document.getElementById("associatedegreedetails").innerHTML = row;

              var assoc_iconNew = $('.add_associatedegreedetails');
              assoc_iconNew.off('click');
              assoc_iconNew.on('click', this.addAssociateDegreeDetails);

              var assoc_iconNew_r = $('.delete_associatedegreedetails');
              assoc_iconNew_r.off('click');
              assoc_iconNew_r.on('click', this.deleteAssociateDegreeDetails);

              var assoc_iconDateSetter = $('.associate-degree-attending');
              assoc_iconDateSetter.off('click');
              assoc_iconDateSetter.on('click', this.openAssocGradDateModal);
          }
      },
      addAssociateDegreeDetails(){
        var container = document.createElement('div');
          container.id = 'associatedegreedetails_template';
          var row = '<div class="el-input associate-degree-title" style="width: 40%;"> <input type="text" autocomplete="off" placeholder="Course Title" class="el-input__inner"> </div> ' +
            '&nbsp;&nbsp; <i class="el-icon-remove delete_associatedegreedetails" style="color: rgb(220, 60, 60); font-size: 20px;" ></i>&nbsp;<i class="el-icon-circle-plus add_associatedegreedetails" style="color: rgb(19, 206, 102); font-size: 20px;"></i> <br>' + 
            '<div class="course-checkbox"><input type="checkbox" class="associate-degree-attending"> <i style="font-size:12px;color:#606266;padding-left: 3px;"> Please mark this checkbox if you are currently attending this program </i> </input></div> ' +
            '<input type="hidden" class="associate-degree-date" autocomplete="off"/>' 
          
          container.innerHTML = row;
          
          var parent = document.getElementById("associatedegreedetails");
          parent.append(container);
          
          var assoc_iconNext = $('.add_associatedegreedetails');
          assoc_iconNext.off('click');
          assoc_iconNext.on('click', this.addAssociateDegreeDetails);

          var assoc_iconNew_r = $('.delete_associatedegreedetails');
              assoc_iconNew_r.off('click');
              assoc_iconNew_r.on('click', this.deleteAssociateDegreeDetails);

          var assoc_iconDateSetter = $('.associate-degree-attending');
            assoc_iconDateSetter.off('click');
            assoc_iconDateSetter.on('click', this.openAssocGradDateModal);
      },
      deleteAssociateDegreeDetails(e){
          var container = e.currentTarget.closest("#associatedegreedetails_template");
          var x = container.parentElement;
          container.remove();
          if(x.innerHTML == '' || x.innerHTML == '<!---->'){
            this.sgaEducation.thirdLevelEducation.associateDegree = false;
          }
      },
      switch_BachelorsDegree(){
          if(!this.sgaEducation.thirdLevelEducation.bachelorsDegree) {
              this.sgaEducation.thirdLevelEducation.bachelorsDegreeDetails = [];
              document.getElementById("bachelorsdegreedetails").innerHTML = '';
          }
          else{
              var row = '<div id="bachelorsdegreedetails_template"><div class="el-input bachelors-degree-title" style="width: 40%;"> <input type="text" autocomplete="off" placeholder="Course Title" class="el-input__inner" /> </div> ' + 
                '&nbsp; &nbsp;<i class="el-icon-remove delete_bachelorsdegreedetails" style="color: rgb(220, 60, 60); font-size: 20px;" ></i>&nbsp;<i class="el-icon-circle-plus add_bachelorsdegreedetails" style="color: rgb(19, 206, 102); font-size: 20px;"></i> <br>' +        
                '<div class="course-checkbox"><input type="checkbox" class="bachelors-degree-attending"> <i style="font-size:12px;color:#606266;padding-left: 3px;"> Please mark this checkbox if you are currently attending this program </i> </div>' +                  
                '<input type="hidden" class="bachelors-degree-date" autocomplete="off"/> </div>'
              
              document.getElementById("bachelorsdegreedetails").innerHTML = row;

              var bs_iconNew = $('.add_bachelorsdegreedetails');
              bs_iconNew.off('click');
              bs_iconNew.on('click', this.addBachelorsDegreeDetails);

              var bs_iconNew_r = $('.delete_bachelorsdegreedetails');
              bs_iconNew_r.off('click');
              bs_iconNew_r.on('click', this.deleteBachelorsDegreeDetails);

              var bs_iconDateSetter = $('.bachelors-degree-attending');
              bs_iconDateSetter.off('click');
              bs_iconDateSetter.on('click', this.openAssocGradDateModal);
          }
      },
      addBachelorsDegreeDetails(){
        var container = document.createElement('div');
          container.id = 'bachelorsdegreedetails_template';
          var row = '<div class="el-input bachelors-degree-title" style="width: 40%;"> <input type="text" autocomplete="off" placeholder="Course Title" class="el-input__inner"> </div> ' +
            '&nbsp; &nbsp;<i class="el-icon-remove delete_bachelorsdegreedetails" style="color: rgb(220, 60, 60); font-size: 20px;" ></i>&nbsp;<i class="el-icon-circle-plus add_bachelorsdegreedetails" style="color: rgb(19, 206, 102); font-size: 20px;"></i> <br>' +
            '<div class="course-checkbox"><input type="checkbox" class="bachelors-degree-attending"> <i style="font-size:12px;color:#606266;padding-left: 3px;"> Please mark this checkbox if you are currently attending this program </i> </input></div> ' +
            '<input type="hidden" class="bachelors-degree-date" autocomplete="off"/>' 
          
          container.innerHTML = row;
          
          var parent = document.getElementById("bachelorsdegreedetails");
          parent.append(container);
          
          var bs_iconNext = $('.add_bachelorsdegreedetails');
          bs_iconNext.off('click');
          bs_iconNext.on('click', this.addBachelorsDegreeDetails);

          var bs_iconNew_r = $('.delete_bachelorsdegreedetails');
              bs_iconNew_r.off('click');
              bs_iconNew_r.on('click', this.deleteBachelorsDegreeDetails);

          var bs_iconDateSetter = $('.bachelors-degree-attending');
            bs_iconDateSetter.off('click');
            bs_iconDateSetter.on('click', this.openAssocGradDateModal);
      },
      deleteBachelorsDegreeDetails(e){
          var container = e.currentTarget.closest("#bachelorsdegreedetails_template");
          var x = container.parentElement;
          container.remove();
          if(x.innerHTML == '' || x.innerHTML == '<!---->'){
            this.sgaEducation.thirdLevelEducation.bachelorsDegree = false;
          }
      },  
      switch_MastersDegree(){
          if(!this.sgaEducation.fourthLevelEducation.mastersDegree) {
              this.sgaEducation.fourthLevelEducation.mastersDegreeDetails = [];
              document.getElementById("mastersdegreedetails").innerHTML = '';
          }
          else{
              var row = '<div id="mastersdegreedetails_template"><div class="el-input masters-degree-title" style="width: 40%;"> <input type="text" autocomplete="off" placeholder="Course Title" class="el-input__inner"> </div> ' + 
                '&nbsp; &nbsp;<i class="el-icon-remove delete_mastersdegreedetails" style="color: rgb(220, 60, 60); font-size: 20px;" ></i>&nbsp;<i class="el-icon-circle-plus add_mastersdegreedetails" style="color: rgb(19, 206, 102); font-size: 20px;"></i> <br>' +                   
                '<div class="course-checkbox"><input type="checkbox" class="masters-degree-attending"> <i style="font-size:12px;color:#606266;padding-left: 3px;"> Please mark this checkbox if you are currently attending this program </i> </input></div>' +                  
                '<input type="hidden" class="masters-degree-date" autocomplete="off"/> </div>'
              
              document.getElementById("mastersdegreedetails").innerHTML = row;

              var ms_iconNew = $('.add_mastersdegreedetails');
              ms_iconNew.off('click');
              ms_iconNew.on('click', this.addMastersDegreeDetails);

              var ms_iconNew_r = $('.delete_mastersdegreedetails');
              ms_iconNew_r.off('click');
              ms_iconNew_r.on('click', this.deleteMastersDegreeDetails);

              var ms_iconDateSetter = $('.masters-degree-attending');
              ms_iconDateSetter.off('click');
              ms_iconDateSetter.on('click', this.openAssocGradDateModal);
          }
      },
      addMastersDegreeDetails(){
          var container = document.createElement('div');
          container.id = 'mastersdegreedetails_template';
          var row = '<div class="el-input masters-degree-title" style="width: 40%;"> <input type="text" autocomplete="off" placeholder="Course Title" class="el-input__inner"> </div> ' + 
            '&nbsp; &nbsp;<i class="el-icon-remove delete_mastersdegreedetails" style="color: rgb(220, 60, 60); font-size: 20px;" ></i>&nbsp;<i class="el-icon-circle-plus add_mastersdegreedetails" style="color: rgb(19, 206, 102); font-size: 20px;"></i> <br>' +              
            '<div class="course-checkbox"><input type="checkbox" class="masters-degree-attending"> <i style="font-size:12px;color:#606266;padding-left: 3px;"> Please mark this checkbox if you are currently attending this program </i> </input></div> ' +
            '<input type="hidden" class="masters-degree-date" autocomplete="off"/>' 
          
          container.innerHTML = row;
          
          var parent = document.getElementById("mastersdegreedetails");
          parent.append(container);
          
          var ms_iconNext = $('.add_mastersdegreedetails');
          ms_iconNext.off('click');
          ms_iconNext.on('click', this.addMastersDegreeDetails);

          var ms_iconNew_r = $('.delete_mastersdegreedetails');
              ms_iconNew_r.off('click');
              ms_iconNew_r.on('click', this.deleteMastersDegreeDetails);

          var ms_iconDateSetter = $('.masters-degree-attending');
            ms_iconDateSetter.off('click');
            ms_iconDateSetter.on('click', this.openAssocGradDateModal);
      },
      deleteMastersDegreeDetails(e){
        
          var container = e.currentTarget.closest("#mastersdegreedetails_template");
          var x = container.parentElement;
          container.remove();
          if(x.innerHTML == '' || x.innerHTML == '<!---->'){
            this.sgaEducation.fourthLevelEducation.mastersDegree = false;
          }
      },
      switch_DoctoralDegree(){
          if(!this.sgaEducation.fourthLevelEducation.doctoralDegree) {
              this.sgaEducation.fourthLevelEducation.doctoralDegreeDetails = [];
              document.getElementById("doctoraldegreedetails").innerHTML = '';
          }
          else{
              var row = '<div id="doctoraldegreedetails_template"><div class="el-input doctoral-degree-title" style="width: 40%;"> <input type="text" autocomplete="off" placeholder="Course Title" class="el-input__inner"> </div> ' + 
                  '&nbsp; &nbsp;<i class="el-icon-remove delete_doctoraldegreedetails" style="color: rgb(220, 60, 60); font-size: 20px;" ></i>&nbsp;<i class="el-icon-circle-plus add_doctoraldegreedetails" style="color: rgb(19, 206, 102); font-size: 20px;"></i> <br>' + 
                  '<div class="course-checkbox"><input type="checkbox" class="doctoral-degree-attending"> <i style="font-size:12px;color:#606266;padding-left: 3px;"> Please mark this checkbox if you are currently attending this program </i> </input></div>' +                  
                  '<input type="hidden" class="doctoral-degree-date" autocomplete="off"/> </div>'
              
              document.getElementById("doctoraldegreedetails").innerHTML = row;

              var phd_iconNew = $('.add_doctoraldegreedetails');
              phd_iconNew.off('click');
              phd_iconNew.on('click', this.addDoctoralDegreeDetails);

              var phd_iconNew_r = $('.delete_doctoraldegreedetails');
              phd_iconNew_r.off('click');
              phd_iconNew_r.on('click', this.deleteDoctoralDegreeDetails);

              var phd_iconDateSetter = $('.doctoral-degree-attending');
              phd_iconDateSetter.off('click');
              phd_iconDateSetter.on('click', this.openAssocGradDateModal);
          }
      },
      addDoctoralDegreeDetails(){
          var container = document.createElement('div');
          container.id = 'doctoraldegreedetails_template';
          var row = '<div class="el-input doctoral-degree-title" style="width: 40%;"> <input type="text" autocomplete="off" placeholder="Course Title" class="el-input__inner"> </div> ' + 
              '&nbsp; &nbsp;<i class="el-icon-remove delete_doctoraldegreedetails" style="color: rgb(220, 60, 60); font-size: 20px;" ></i>&nbsp;<i class="el-icon-circle-plus add_doctoraldegreedetails" style="color: rgb(19, 206, 102); font-size: 20px;"></i> <br>' +
              '<div class="course-checkbox"><input type="checkbox" class="doctoral-degree-attending"> <i style="font-size:12px;color:#606266;padding-left: 3px;"> Please mark this checkbox if you are currently attending this program </i> </input></div> ' +
              '<input type="hidden" class="doctoral-degree-date" autocomplete="off"/>'  
          
          container.innerHTML = row;
          
          var parent = document.getElementById("doctoraldegreedetails");
          parent.append(container);
          
          var phd_iconNext = $('.add_doctoraldegreedetails');
          phd_iconNext.off('click');
          phd_iconNext.on('click', this.addDoctoralDegreeDetails);

          var phd_iconNew_r = $('.delete_doctoraldegreedetails');
              phd_iconNew_r.off('click');
              phd_iconNew_r.on('click', this.deleteDoctoralDegreeDetails);

          var phd_iconDateSetter = $('.doctoral-degree-attending');
            phd_iconDateSetter.off('click');
            phd_iconDateSetter.on('click', this.openAssocGradDateModal);
      },
      deleteDoctoralDegreeDetails(e){
          var container = e.currentTarget.closest("#doctoraldegreedetails_template");
          var x = container.parentElement;
          container.remove();
          if(x.innerHTML == '' || x.innerHTML == '<!---->'){
            this.sgaEducation.fourthLevelEducation.doctoralDegree = false;
          }
      },
      switch_Experience(){
        this.sgaEducation.sectorExperience.experienceDetails = [];
          if(this.sgaEducation.sectorExperience.experience) {
              this.sgaEducation.sectorExperience.experienceDetails.push({'title': this.naicsLevel1Options[0].title, 'years': 'Less than one year'});
          }
      },
      addExperienceDetails(){
        var x =  { title: '', years: '' };
        this.sgaEducation.sectorExperience.experienceDetails.push(x);
      },
      deleteExperienceDetails(e){
        var container = e.currentTarget.closest("#experiencedetails_template");
        var x = container.parentElement;
        container.remove();
        if(x.innerHTML == '' || x.innerHTML == '<!---->'){
          this.sgaEducation.sectorExperience.experience = false;
          this.sgaEducation.sectorExperience.experienceDetails = [];
        }
      },
      storeSection() {
          this.isLoading = true;
          this.currentSga.sgaEmployeeInfo = this.sgaEmployeeInfo;
          if (this.getOLevelList() == false ||
          this.getALevelList() == false ||
          this.getAssociateDegreeList() == false ||
          this.getBachelorsDegreeList() == false ||
          this.getMastersDegreeList() == false ||
          this.getDoctoralDegreeList() == false || 
          this.getExperience() == false){
            $('div[role=alert]').show();
            this.isLoading = false;
            return false;
          }

          if(this.validatedGradudationDates()) {
            this.isLoading = false;
            return false;
          }

          this.currentSga.sgaEducation = this.sgaEducation;
          this.currentSga.sgaEducation.isComplete = true;
          if (this.currentSga.sgaEducation.id == null) {
            this.$store
              .dispatch("sga/postsga", this.currentSga)
              .then(() => {
                this.$router.app.$emit("navigateToNextStep");
              })
              .catch((res) => {
                this.modelState = res.errors;
                this.isLoading = false;
              })
              .finally(() => {
                this.isLoading = false;
              });
          } else {
            this.$store
              .dispatch("sga/putsga", this.currentSga)
              .then(() => {
                this.$router.app.$emit("navigateToNextStep");
              })
              .catch((res) => {
                this.modelState = res.errors;
                this.isLoading = false;
              })
              .finally(() => {
                this.isLoading = false;
              });
          }
        sessionStorage.setItem('sgaDataForPrinting', JSON.stringify({ 
        page1: this.page1, 
        page2: this.page2, 
        page3: { sgaEducation: this.currentSga.sgaEducation }}));
      },
      getOLevelList(){
         var list = $('#oleveldetails').find('div[id=oleveldetails_template]');
        var _olist = [];
        var _error = '';
        $.each(list, function(key, item) {
          let _grade = '';
          let _subject = '';
          _grade = document.getElementsByClassName('o-level-grade')[key].firstElementChild.firstElementChild.value;
          _subject =  document.getElementsByClassName('o-level-subject')[key].firstElementChild.value;

          _olist.push({'Grade': _grade, 'Subject': _subject});

          if(_grade == '' || _subject == ''){
             _error = 'error found';
            return false;
          }
        });
        
        if(_error != '')return false;
        this.sgaEducation.secondLevelEducation.oLevelDetails = _olist;
      },
      getALevelList(){
        var list = $('#aleveldetails').find('div[id=aleveldetails_template]');
        var _alist = [];
        var _error = '';
        $.each(list, function(key, item) {
          let _grade = '';
          let _subject = '';
          _grade = document.getElementsByClassName('a-level-grade')[key].firstElementChild.firstElementChild.value;
          _subject =  document.getElementsByClassName('a-level-subject')[key].firstElementChild.value;

          _alist.push({'Grade': _grade, 'Subject': _subject});
          if(_grade == '' || _subject == ''){
             _error = 'error found';
            return false;
          }
        });
        
        if(_error != '')return false;
        this.sgaEducation.secondLevelEducation.aLevelDetails = _alist;
      },
      getAssociateDegreeList(){
        var list = $('#associatedegreedetails').find('div[id=associatedegreedetails_template]');
        var _title = [];
        var _error = '';
        $.each(list, function(key, item) {
          let _course = document.getElementsByClassName('associate-degree-title')[key].firstElementChild.value;
          let _currentlyAttending = null;
          if(document.getElementsByClassName('associate-degree-attending')[key].classList.contains('el-checkbox')) _currentlyAttending = document.getElementsByClassName('associate-degree-attending')[key].firstElementChild.firstElementChild.nextElementSibling.checked;
          else _currentlyAttending = document.getElementsByClassName('associate-degree-attending')[key].checked;
          let _graduationDate = document.getElementsByClassName('associate-degree-date')[key].value

          _title.push({'CourseTitle':_course, 'currentlyAttending': _currentlyAttending, 'graduationDate': new Date(_graduationDate)});
          if(_course == ''){
             _error = 'error found';
            return false;
          }
        });
        
        if(_error != '')return false;
        this.sgaEducation.thirdLevelEducation.associateDegreeDetails = _title;
      },
      getBachelorsDegreeList(){
        var list = $('#bachelorsdegreedetails').find('div[id=bachelorsdegreedetails_template]');
        var _title = [];
        var _error = '';
        $.each(list, function(key, item) {
          let _course = document.getElementsByClassName('bachelors-degree-title')[key].firstElementChild.value;
          let _currentlyAttending = null;
          if(document.getElementsByClassName('bachelors-degree-attending')[key].classList.contains('el-checkbox')) _currentlyAttending = document.getElementsByClassName('bachelors-degree-attending')[key].firstElementChild.firstElementChild.nextElementSibling.checked;
          else _currentlyAttending = document.getElementsByClassName('bachelors-degree-attending')[key].checked;
          let _graduationDate = document.getElementsByClassName('bachelors-degree-date')[key].value

          _title.push({'CourseTitle':_course, 'currentlyAttending': _currentlyAttending, 'graduationDate': new Date(_graduationDate)});
          if(_course == ''){
             _error = 'error found';
            return false;
          }
        });
        
        if(_error != '')return false;
        this.sgaEducation.thirdLevelEducation.bachelorsDegreeDetails = _title;
      },
      getMastersDegreeList(){
        var list = $('#mastersdegreedetails').find('div[id=mastersdegreedetails_template]');
        var _title = [];
        var _error = '';
        $.each(list, function(key, item) {
          let _course = document.getElementsByClassName('masters-degree-title')[key].firstElementChild.value;
          let _currentlyAttending = null;
          if(document.getElementsByClassName('masters-degree-attending')[key].classList.contains('el-checkbox')) _currentlyAttending = document.getElementsByClassName('masters-degree-attending')[key].firstElementChild.firstElementChild.nextElementSibling.checked;
          else _currentlyAttending = document.getElementsByClassName('masters-degree-attending')[key].checked;
          let _graduationDate = document.getElementsByClassName('masters-degree-date')[key].value

          _title.push({'CourseTitle':_course, 'currentlyAttending': _currentlyAttending, 'graduationDate': new Date(_graduationDate)});
          if(_course == ''){
             _error = 'error found';
            return false;
          }
        });
        
        if(_error != '')return false;
        this.sgaEducation.fourthLevelEducation.mastersDegreeDetails = _title;
      },
      getDoctoralDegreeList(){
        var list = $('#doctoraldegreedetails').find('div[id=doctoraldegreedetails_template]');
        var _title = [];
        var _error = '';
        $.each(list, function(key, item) {
          let _course = document.getElementsByClassName('doctoral-degree-title')[key].firstElementChild.value;
          let _currentlyAttending = null;
          if(document.getElementsByClassName('doctoral-degree-attending')[key].classList.contains('el-checkbox')) _currentlyAttending = document.getElementsByClassName('doctoral-degree-attending')[key].firstElementChild.firstElementChild.nextElementSibling.checked;
          else _currentlyAttending = document.getElementsByClassName('doctoral-degree-attending')[key].checked;
          let _graduationDate = document.getElementsByClassName('doctoral-degree-date')[key].value

          _title.push({'CourseTitle':_course, 'currentlyAttending': _currentlyAttending, 'graduationDate': new Date(_graduationDate)});
          if(_course == ''){
             _error = 'error found';
            return false;
          }
        });
        
        if(_error != '')return false;
        this.sgaEducation.fourthLevelEducation.doctoralDegreeDetails = _title;
      },
      getExperience(){
        var list = $('#experiencedetails').find('div[id=experiencedetails_template]');
        var _explist = [];
        var _error = '';
        $.each(list, function(key, item) {
          //let _sector = document.getElementsByClassName('experience-sector')[key].firstElementChild.textContent;
          //let _years = document.getElementsByClassName('experience-years')[key].firstElementChild.value;
          // let _idx =  document.getElementsByClassName('experience-sector')[key].firstElementChild.selectedIndex;
          // let _sector = document.getElementsByClassName('experience-sector')[key].firstElementChild[_idx].text;
          let _sector = '';
          let _years = '';
          let el_indicator = document.getElementsByClassName('experience-sector')[key].firstElementChild.className;
          if(el_indicator != 'el-input__inner'){
            _sector = document.getElementsByClassName('experience-sector')[key].firstElementChild.firstElementChild.value;
            _years = document.getElementsByClassName('experience-years')[key].firstElementChild.firstElementChild.value;
          }else{
            let _idx_sector =  document.getElementsByClassName('experience-sector')[key].firstElementChild.selectedIndex;
            _sector = document.getElementsByClassName('experience-sector')[key].firstElementChild[_idx_sector].text;
            let _idx_years =  document.getElementsByClassName('experience-years')[key].firstElementChild.selectedIndex;
            _years = document.getElementsByClassName('experience-years')[key].firstElementChild[_idx_years].text;
          }

          _explist.push({'title': _sector, 'years': _years});
          if(_sector == '' || _years == ''){
             _error = 'error found';
            return false;
          }
        });

        if (_error != "") return false;
        this.sgaEducation.sectorExperience.experienceDetails = _explist;
      },
    printPage(action) {
      this.loadPages(action);
    },
    loadPages(action) {
      this.$store.dispatch('sga/getsga').then((data) => {
        this.sgaYourJob = data.sgaYourJob || this.sgaYourJob;
        this.sgaWorkHistory = data.sgaWorkHistory || this.sgaWorkHistory;
        this.sgaCertifications = data.sgaCertifications || this.sgaCertifications;
        this.sgaHiddenExtras = data.sgaHiddenExtras || this.sgaHiddenExtras;
        this.sgaKnowledge = data.sgaKnowledge || this.sgaKnowledge;
        this.sgaMindset = data.sgaMindset || this.sgaMindset;
        this.sgaSkills = data.sgaSkills || this.sgaSkills;
        this.sgaHiddenTalents = data.sgaHiddenTalents || this.sgaHiddenTalents;
        this.sgaCulture = data.culture || this.sgaCulture;
        this.sgaTechnologies = data.sgaTechnologies || this.sgaTechnologies;

        this.$store.dispatch('sga/getSGAforPrint', this.sgaHiddenExtras).then(() => {
          this.$refs.cv.hideCV();
          this.$refs.questionnaire.showQuestionnaire();
          action();
          this.$refs.questionnaire.hideQuestionnaire();
        });
      });
    },
    printPageAsCV(action) {
      this.cvCollection = [
        {
          userInfo: this.currentUser,
          Image: this.base64Raw,
          survey: this.currentSga,
        },
      ];
      this.$confirm(`Do you want to include profile picture?`, "Warning", {
        confirmButtonText: "Yes",
        dangerouslyUseHTMLString: true,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "No",
        center: true,
      })
        .then(() => {
          this.$refs.cv.showCV(true);
          this.showProfile = true;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function () {
            action();
            x();
          }, 500);
          //this.$refs.cv.hideCV();
        })
        .catch(() => {
          this.$refs.cv.showCV(false);
          this.showProfile = false;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function () {
            action();
            x();
          }, 500);
        });
    },
    handleChangeNoGEDOrHSD() {
      if(this.sgaEducation.secondLevelEducation.noGedOrHsd) {
        this.sgaEducation.secondLevelEducation.highSchoolDiploma = false;
        this.sgaEducation.secondLevelEducation.highSchoolDiplomaAttending = false;
        this.sgaEducation.secondLevelEducation.highSchoolDiplomaGraduationDate = null;
        this.sgaEducation.secondLevelEducation.ged = false;
        this.sgaEducation.secondLevelEducation.gedAttending = false;
        this.sgaEducation.secondLevelEducation.gedGraduationDate = null;
      }
    },
    handleChangeGEDOrHSD() {
      if(this.sgaEducation.secondLevelEducation.highSchoolDiploma || this.sgaEducation.secondLevelEducation.ged) {
        this.sgaEducation.secondLevelEducation.noGedOrHsd = false;        
      }

      if(!this.sgaEducation.secondLevelEducation.highSchoolDiploma) {
          this.sgaEducation.secondLevelEducation.highSchoolDiplomaAttending = false;
          this.sgaEducation.secondLevelEducation.highSchoolDiplomaGraduationDate = null;
      } else if (!this.sgaEducation.secondLevelEducation.ged) {
         this.sgaEducation.secondLevelEducation.gedAttending = false;
         this.sgaEducation.secondLevelEducation.gedGraduationDate = null;
      }
    },

    //
    openGradDateModal(val, graduationDate, isChecked) {
      if (isChecked) {
        if (graduationDate == "0001-01-01T00:00:00" || graduationDate == null)
          this.selectedGradDate = null;
        else this.selectedGradDate = graduationDate;

        this.optionToSetDate = val;
        this.showDateModal = true;
        this.isFromElementUI = false;
      }
    },
    setGraduationDate() {
      this.selectedGradDateError = null;

      if (this.selectedGradDate == null || this.selectedGradDate == "") {
        this.selectedGradDateError =
          "Estimated graduation date field is required.";
      } else if (this.selectedGradDate < new Date()) {
        this.selectedGradDateError =
          "Estimated graduation date must be a future date.";
      } else {
        if (this.isFromElementUI) {
          if (this.optionToSetDate == "associatedegreedetails_template") {
            this.htmlElem.previousElementSibling.previousElementSibling.lastElementChild.innerText =
              "Currently attending, estimated graduation date is " +
              this.$moment(this.selectedGradDate).format("MMMM DD, YYYY");
            this.htmlElem.value = this.selectedGradDate;
          } else if (
            this.optionToSetDate == "bachelorsdegreedetails_template"
          ) {
            this.htmlElem.previousElementSibling.previousElementSibling.lastElementChild.innerText =
              "Currently attending, estimated graduation date is " +
              this.$moment(this.selectedGradDate).format("MMMM DD, YYYY");
            this.htmlElem.value = this.selectedGradDate;
          } else if (this.optionToSetDate == "mastersdegreedetails_template") {
            this.htmlElem.previousElementSibling.previousElementSibling.lastElementChild.innerText =
              "Currently attending, estimated graduation date is " +
              this.$moment(this.selectedGradDate).format("MMMM DD, YYYY");
            this.htmlElem.value = this.selectedGradDate;
          } else if (this.optionToSetDate == "doctoraldegreedetails_template") {
            this.htmlElem.previousElementSibling.previousElementSibling.lastElementChild.innerText =
              "Currently attending, estimated graduation date is " +
              this.$moment(this.selectedGradDate).format("MMMM DD, YYYY");
            this.htmlElem.value = this.selectedGradDate;
          }
        } else {

          if(this.optionToSetDate == 'HSD') {            
            this.sgaEducation.secondLevelEducation.highSchoolDiploma = true;
            this.sgaEducation.secondLevelEducation.highSchoolDiplomaGraduationDate = this.selectedGradDate;

          } else if(this.optionToSetDate == 'GED') {
            this.sgaEducation.secondLevelEducation.ged = true;
            this.sgaEducation.secondLevelEducation.gedGraduationDate = this.selectedGradDate;

          } else if(this.optionToSetDate == 'associatedegreedetails_template') {
            this.htmlElem.previousElementSibling.firstElementChild.nextElementSibling.innerText = 'Currently attending, estimated graduation date is '+ this.$moment(this.selectedGradDate).format("MMMM DD, YYYY");
            this.htmlElem.previousElementSibling.firstElementChild.nextElementSibling.style.color = '#14223c';
            this.htmlElem.value = this.selectedGradDate;
          } else if (
            this.optionToSetDate == "bachelorsdegreedetails_template"
          ) {
            this.htmlElem.previousElementSibling.firstElementChild.nextElementSibling.innerText =
              "Currently attending, estimated graduation date is " +
              this.$moment(this.selectedGradDate).format("MMMM DD, YYYY");
            this.htmlElem.previousElementSibling.firstElementChild.nextElementSibling.style.color =
              "#14223c";
            this.htmlElem.value = this.selectedGradDate;
          } else if (this.optionToSetDate == "mastersdegreedetails_template") {
            this.htmlElem.previousElementSibling.firstElementChild.nextElementSibling.innerText =
              "Currently attending, estimated graduation date is " +
              this.$moment(this.selectedGradDate).format("MMMM DD, YYYY");
            this.htmlElem.previousElementSibling.firstElementChild.nextElementSibling.style.color =
              "#14223c";
            this.htmlElem.value = this.selectedGradDate;
          } else if (this.optionToSetDate == "doctoraldegreedetails_template") {
            this.htmlElem.previousElementSibling.firstElementChild.nextElementSibling.innerText =
              "Currently attending, estimated graduation date is " +
              this.$moment(this.selectedGradDate).format("MMMM DD, YYYY");
            this.htmlElem.previousElementSibling.firstElementChild.nextElementSibling.style.color =
              "#14223c";
            this.htmlElem.value = this.selectedGradDate;
          }
        }

        this.isFromElementUI = false;
        this.selectedGradDate = null;
        this.showDateModal = false;
      }
    },
    closeDateModal() {
      var isChecked = false;

      if (this.isFromElementUI) {
        if (this.optionToSetDate == "associatedegreedetails_template") {
          isChecked =
            this.htmlElem.previousElementSibling.previousElementSibling
              .firstElementChild.firstElementChild.nextElementSibling.checked;
          this.htmlElem.previousElementSibling.previousElementSibling.firstElementChild.firstElementChild.nextElementSibling.checked =
            !isChecked;
          this.htmlElem.previousElementSibling.previousElementSibling.classList.remove(
            "is-checked"
          );
          this.htmlElem.previousElementSibling.previousElementSibling.firstElementChild.classList.remove(
            "is-checked"
          );
          this.htmlElem.previousElementSibling.previousElementSibling.lastElementChild.innerText =
            "Please mark this checkbox if you are currently attending this program";
          this.htmlElem.previousElementSibling.previousElementSibling.nextElementSibling.nextElementSibling.value =
            null;
        } else if (this.optionToSetDate == "bachelorsdegreedetails_template") {
          isChecked =
            this.htmlElem.previousElementSibling.previousElementSibling
              .firstElementChild.firstElementChild.nextElementSibling.checked;
          this.htmlElem.previousElementSibling.previousElementSibling.firstElementChild.firstElementChild.nextElementSibling.checked =
            !isChecked;
          this.htmlElem.previousElementSibling.previousElementSibling.classList.remove(
            "is-checked"
          );
          this.htmlElem.previousElementSibling.previousElementSibling.firstElementChild.classList.remove(
            "is-checked"
          );
          this.htmlElem.previousElementSibling.previousElementSibling.lastElementChild.innerText =
            "Please mark this checkbox if you are currently attending this program";
          this.htmlElem.previousElementSibling.previousElementSibling.nextElementSibling.nextElementSibling.value =
            null;
        } else if (this.optionToSetDate == "mastersdegreedetails_template") {
          isChecked =
            this.htmlElem.previousElementSibling.previousElementSibling
              .firstElementChild.firstElementChild.nextElementSibling.checked;
          this.htmlElem.previousElementSibling.previousElementSibling.firstElementChild.firstElementChild.nextElementSibling.checked =
            !isChecked;
          this.htmlElem.previousElementSibling.previousElementSibling.classList.remove(
            "is-checked"
          );
          this.htmlElem.previousElementSibling.previousElementSibling.firstElementChild.classList.remove(
            "is-checked"
          );
          this.htmlElem.previousElementSibling.previousElementSibling.lastElementChild.innerText =
            "Please mark this checkbox if you are currently attending this program";
          this.htmlElem.previousElementSibling.previousElementSibling.nextElementSibling.nextElementSibling.value =
            null;
        } else if (this.optionToSetDate == "doctoraldegreedetails_template") {
          isChecked =
            this.htmlElem.previousElementSibling.previousElementSibling
              .firstElementChild.firstElementChild.nextElementSibling.checked;
          this.htmlElem.previousElementSibling.previousElementSibling.firstElementChild.firstElementChild.nextElementSibling.checked =
            !isChecked;
          this.htmlElem.previousElementSibling.previousElementSibling.classList.remove(
            "is-checked"
          );
          this.htmlElem.previousElementSibling.previousElementSibling.firstElementChild.classList.remove(
            "is-checked"
          );
          this.htmlElem.previousElementSibling.previousElementSibling.lastElementChild.innerText =
            "Please mark this checkbox if you are currently attending this program";
          this.htmlElem.previousElementSibling.previousElementSibling.nextElementSibling.nextElementSibling.value =
            null;
        }
      } else {

        if(this.optionToSetDate == 'HSD') {

          this.sgaEducation.secondLevelEducation.highSchoolDiplomaAttending = !this.sgaEducation.secondLevelEducation.highSchoolDiplomaAttending;
        } else if(this.optionToSetDate == 'GED') {

          this.sgaEducation.secondLevelEducation.gedAttending = !this.sgaEducation.secondLevelEducation.gedAttending;
        } else if(this.optionToSetDate == 'associatedegreedetails_template') {

          this.htmlElem.previousElementSibling.firstElementChild.checked = !this.htmlElem.previousElementSibling.firstElementChild.checked;
        } else if(this.optionToSetDate == 'bachelorsdegreedetails_template') {
          
          this.htmlElem.previousElementSibling.firstElementChild.checked = !this.htmlElem.previousElementSibling.firstElementChild.checked;
        } else if(this.optionToSetDate == 'mastersdegreedetails_template') {

          this.htmlElem.previousElementSibling.firstElementChild.checked = !this.htmlElem.previousElementSibling.firstElementChild.checked;
        } else if(this.optionToSetDate == 'doctoraldegreedetails_template') {
          
          this.htmlElem.previousElementSibling.firstElementChild.checked = !this.htmlElem.previousElementSibling.firstElementChild.checked;
        }
      }

      this.selectedGradDateError = null;
      this.selectedGradDate = null;
      this.optionToSetDate = null;
      this.isFromElementUI = false;
      this.showDateModal = false;
    },

    openAssocGradDateModal(val) {
      if (val == undefined) {
        if (event.currentTarget.checked) {
          // Assign values
          this.optionToSetDate =
            event.currentTarget.parentElement.parentElement.parentElement.id;
          this.htmlElem =
            event.currentTarget.parentElement.parentElement.nextElementSibling.nextElementSibling;
          this.isFromElementUI = true;
          this.showDateModal = true;
        } else {
          // Remove values
          event.currentTarget.parentElement.parentElement.lastElementChild.innerText =
            "Please mark this checkbox if you are currently attending this program";
          event.currentTarget.parentElement.parentElement.nextElementSibling.nextElementSibling.value =
            null;
        }
      } else {
        if (val.currentTarget.checked) {
          // Assign values
          this.optionToSetDate =
            val.currentTarget.parentElement.parentElement.id;
          this.htmlElem = val.currentTarget.parentElement.nextElementSibling;
          this.showDateModal = true;
        } else {
          // Remove values
          val.currentTarget.nextElementSibling.innerText =
            "Please mark this checkbox if you are currently attending this program";
          val.currentTarget.nextElementSibling.style.color = "#606266";
          val.currentTarget.parentElement.nextElementSibling.value = null;
        }
      }
    },
    populatDateHiddenFields() {
      
      var educ = this.sgaEducation;
      // Populate associate degree
      var associate = $('#associatedegreedetails').find('div[id=associatedegreedetails_template]');
      $.each(associate, function(key, item) {   
        document.getElementsByClassName('associate-degree-date')[key].value = educ.thirdLevelEducation.associateDegreeDetails[key].graduationDate;
      });

      // Populate bachelors degree
      var bachelor = $('#bachelorsdegreedetails').find('div[id=bachelorsdegreedetails_template]');
      $.each(bachelor, function(key, item) {   
        document.getElementsByClassName('bachelors-degree-date')[key].value = educ.thirdLevelEducation.bachelorsDegreeDetails[key].graduationDate;
      });

      // Populate masters degree
      var masters = $('#mastersdegreedetails').find('div[id=mastersdegreedetails_template]');
      $.each(masters, function(key, item) {   
        document.getElementsByClassName('masters-degree-date')[key].value = educ.fourthLevelEducation.mastersDegreeDetails[key].graduationDate;
      });

      // Populate doctoral degree
      var doctoral = $('#doctoraldegreedetails').find('div[id=doctoraldegreedetails_template]');
      $.each(doctoral, function(key, item) {   
        document.getElementsByClassName('doctoral-degree-date')[key].value = educ.fourthLevelEducation.doctoralDegreeDetails[key].graduationDate;
      });
    },
    validatedGradudationDates() {
      let err = false;
      var alist = $("#associatedegreedetails").find(
        "div[id=associatedegreedetails_template]"
      );
      $.each(alist, function (key, item) {
        let _currentlyAttending = null;
        if (
          document
            .getElementsByClassName("associate-degree-attending")
            [key].classList.contains("el-checkbox")
        )
          _currentlyAttending = document.getElementsByClassName(
            "associate-degree-attending"
          )[key].firstElementChild.firstElementChild.nextElementSibling.checked;
        else
          _currentlyAttending = document.getElementsByClassName(
            "associate-degree-attending"
          )[key].checked;
        let _graduationDate = document.getElementsByClassName(
          "associate-degree-date"
        )[key].value;

        if (_currentlyAttending && new Date(_graduationDate) < new Date()) {
          err = true;
          return true;
        }
      });

      this.assocDateErr = err;
      if (err) return err;

      var blist = $("#bachelorsdegreedetails").find(
        "div[id=bachelorsdegreedetails_template]"
      );
      $.each(blist, function (key, item) {
        let _currentlyAttending = null;
        if (
          document
            .getElementsByClassName("bachelors-degree-attending")
            [key].classList.contains("el-checkbox")
        )
          _currentlyAttending = document.getElementsByClassName(
            "bachelors-degree-attending"
          )[key].firstElementChild.firstElementChild.nextElementSibling.checked;
        else
          _currentlyAttending = document.getElementsByClassName(
            "bachelors-degree-attending"
          )[key].checked;
        let _graduationDate = document.getElementsByClassName(
          "bachelors-degree-date"
        )[key].value;

        if (_currentlyAttending && new Date(_graduationDate) < new Date()) {
          err = true;
          return true;
        }
      });

      this.batchDateErr = err;
      if (err) return err;

      var mlist = $("#mastersdegreedetails").find(
        "div[id=mastersdegreedetails_template]"
      );
      $.each(mlist, function (key, item) {
        let _currentlyAttending = null;
        if (
          document
            .getElementsByClassName("masters-degree-attending")
            [key].classList.contains("el-checkbox")
        )
          _currentlyAttending = document.getElementsByClassName(
            "masters-degree-attending"
          )[key].firstElementChild.firstElementChild.nextElementSibling.checked;
        else
          _currentlyAttending = document.getElementsByClassName(
            "masters-degree-attending"
          )[key].checked;
        let _graduationDate = document.getElementsByClassName(
          "masters-degree-date"
        )[key].value;

        if (_currentlyAttending && new Date(_graduationDate) < new Date()) {
          err = true;
          return true;
        }
      });

      this.masterDateErr = err;
      if (err) return err;

      var dlist = $("#doctoraldegreedetails").find(
        "div[id=doctoraldegreedetails_template]"
      );
      $.each(dlist, function (key, item) {
        let _currentlyAttending = null;
        if (
          document
            .getElementsByClassName("doctoral-degree-attending")
            [key].classList.contains("el-checkbox")
        )
          _currentlyAttending = document.getElementsByClassName(
            "doctoral-degree-attending"
          )[key].firstElementChild.firstElementChild.nextElementSibling.checked;
        else
          _currentlyAttending = document.getElementsByClassName(
            "doctoral-degree-attending"
          )[key].checked;
        let _graduationDate = document.getElementsByClassName(
          "doctoral-degree-date"
        )[key].value;

        if (_currentlyAttending && new Date(_graduationDate) < new Date()) {
          err = true;
          return true;
        }
      });

      this.masterDateErr = err;
      return err;
    }
  },
};
</script>

<style lang="scss">
.test {
  position: absolute;
  top: 100%;
  right: 0;
  left: 0;
  z-index: 999;
  margin: 0 0;
  padding: 0 0;
  list-style: none;
  border: 1px solid #ccc;
  background-color: white;
  -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.educ_alert p {
  margin-top: 0px !important;
}

@media screen and (max-width: 759px) {
  .experience-years {
    width: 40% !important;
  }
}

.el-checkbox,
.course-checkbox {
  padding: 10px;
}

.el-checkbox__label {
  margin-top: -3px !important;
}
</style>
